export const desktop = '58rem';
export const tablet = '40rem';
export const red = '#D34022';
export const pink = '#f1dbc7';
export const yellow = '#ff9e3a';
export const green = '#17261f';
